document.addEventListener('DOMContentLoaded', function() {
  const slider = document.getElementById('mainBannerSlider');
  const paginationItems = document.querySelectorAll('.hero-pagination-item');
  const slides = slider.querySelectorAll('.slider__slide');
  const prevButton = document.querySelector('.hero-banner-wrapper .slider-button--prev');
  const nextButton = document.querySelector('.hero-banner-wrapper .slider-button--next');
  
  let currentSlide = 0;
  let autoplayInterval;
  let isScrolling = false;
  let isDragging = false;
  let startX, startScrollLeft;
  let dragThreshold = 5; // Pixels required to be considered a drag vs a click
  let dragStartTime = 0;
  let hasMoved = false;
  
  // Initialize pagination
  updatePagination(0);
  
  // Prevent default behavior on images
  slider.querySelectorAll('img').forEach(img => {
    img.addEventListener('dragstart', (e) => e.preventDefault());
  });
  
  // Basic drag functionality with improved thresholds
  slider.addEventListener('mousedown', dragStart);
  slider.addEventListener('touchstart', dragStart, { passive: true });
  slider.addEventListener('mousemove', drag);
  slider.addEventListener('touchmove', drag, { passive: false });
  window.addEventListener('mouseup', dragEnd);
  window.addEventListener('touchend', dragEnd);
  
  // Add click handlers for the navigation buttons
  if (prevButton) {
    prevButton.addEventListener('click', function(e) {
      e.preventDefault();
      navigateSlide('prev');
    });
  }
  
  if (nextButton) {
    nextButton.addEventListener('click', function(e) {
      e.preventDefault();
      navigateSlide('next');
    });
  }
  
  function navigateSlide(direction) {
    let targetSlide = currentSlide;
    
    if (direction === 'next') {
      targetSlide = (currentSlide + 1) % slides.length;
    } else {
      targetSlide = (currentSlide - 1 + slides.length) % slides.length;
    }
    
    scrollToSlide(targetSlide);
    updatePagination(targetSlide);
  }
  
  function dragStart(e) {
    if (!e.touches && e.button !== 0) return; // Only left mouse button
    
    // Stop event propagation to prevent unwanted page scrolling
    // but only for horizontal movements
    if (e.type === 'mousedown') {
      e.preventDefault();
    }
    
    isDragging = true;
    hasMoved = false;
    dragStartTime = Date.now();
    startX = e.pageX || e.touches[0].pageX;
    startScrollLeft = slider.scrollLeft;
    slider.style.scrollBehavior = 'auto';
    slider.classList.add('grabbing');
    
    // Pause autoplay during drag
    clearInterval(autoplayInterval);
  }
  
  function drag(e) {
    if (!isDragging) return;
    
    const x = e.pageX || (e.touches ? e.touches[0].pageX : startX);
    const walkX = startX - x;
    
    // Only consider it a drag if moved more than the threshold
    if (Math.abs(walkX) > dragThreshold) {
      hasMoved = true;
      
      // Prevent page scrolling during horizontal slider drag
      if (e.cancelable) {
        e.preventDefault();
      }
      
      slider.scrollLeft = startScrollLeft + walkX;
    }
  }
  
  function dragEnd(e) {
    if (!isDragging) return;
    
    isDragging = false;
    slider.classList.remove('grabbing');
    
    // Only snap if it was an actual drag, not just a click
    if (hasMoved) {
      // Snap to nearest slide
      const slideWidth = slider.querySelector('.slider__slide').offsetWidth;
      const index = Math.round(slider.scrollLeft / slideWidth);
      
      // Use smooth scroll behavior for snapping
      slider.style.scrollBehavior = 'smooth';
      scrollToSlide(index);
    }
    
    // Resume autoplay
    startAutoplay();
  }

  // Add click handler to banner links
  slides.forEach(slide => {
    const link = slide.querySelector('a');
    if (link) {
      link.addEventListener('click', function(e) {
        // If it was a drag, prevent the click
        if (hasMoved) {
          e.preventDefault();
        }
      });
    }
  });

  // Handle pagination clicks
  paginationItems.forEach((item, index) => {
    item.addEventListener('click', () => {
      scrollToSlide(index);
      updatePagination(index);
      startAutoplay();
    });
  });
  
  // Scroll to specific slide
  function scrollToSlide(index) {
    isScrolling = true;
    currentSlide = index % slides.length;
    
    const slideWidth = slider.querySelector('.slider__slide').offsetWidth;
    slider.style.scrollBehavior = 'smooth';
    slider.scrollTo({
      left: slideWidth * currentSlide,
      behavior: 'smooth'
    });
    
    setTimeout(() => {
      isScrolling = false;
    }, 400);
  }

  // Update pagination indicators
  function updatePagination(activeIndex) {
    paginationItems.forEach((item, index) => {
      if (index === activeIndex % slides.length) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });
  }
  
  // Autoplay functionality
  function startAutoplay() {
    clearInterval(autoplayInterval);
    autoplayInterval = setInterval(() => {
      if (isScrolling || isDragging) return;
      
      currentSlide = (currentSlide + 1) % slides.length;
      scrollToSlide(currentSlide);
      updatePagination(currentSlide);
    }, 5000);
  }
  
  // Start autoplay on load
  startAutoplay();
  
  // Update on scroll
  slider.addEventListener('scroll', function() {
    if (isScrolling || isDragging) return;
    
    const slideWidth = slider.querySelector('.slider__slide').offsetWidth;
    let index = Math.round(slider.scrollLeft / slideWidth);
    index = index % slides.length;
    
    if (currentSlide !== index) {
      currentSlide = index;
      updatePagination(currentSlide);
    }
  });
});
